<template>
  <div
    id="intro"
    class="app-container content-container"
  >
    <div v-show="page === 1">
      <div class="jumbotron">
        <img
          src="static/img/hello.png"
          alt="hello"
        >
      </div>
      <h1>
        HI THERE!<br>
        WELCOME ON BOARD :)
      </h1>
      <p>
        Find out what’s hidden behind the term fake news and learn to
        recognize any fakes that come your way.
        There are a few tricks of the trade worth knowing if you don’t
        want to get lost in the world of omnipresent misinformation.
        The tricks will also help you navigate the game.
      </p>
    </div>

    <div v-show="page === 2">
      <div class="jumbotron">
        <img
          src="static/img/fake_news.png"
          alt="fake news"
        >
      </div>
      <h1>
        FAKE NEWS: WHAT IS IT?
      </h1>
      <p>
        <b>
          Fake news is any piece of false information presented as true
          and spread online or by means of traditional media outlets.
        </b>
        It is usually created with an aim to reach
        a certain political, financial or personal goal.
      </p>
    </div>

    <div v-show="page === 3">
      <div class="jumbotron">
        <img
          src="static/img/source.png"
          alt="source"
        >
      </div>
      <h1>
        FIRST – <br>
        CHECK SOURCES
      </h1>
      <p>
        While browsing through posts and articles on social media make
        sure you always check their source. False websites
        are often openly satirical or disguised as trustworthy.
        <b>Stay alert to the name and design of a website.</b>
      </p>
    </div>

    <div v-show="page === 4">
      <div class="jumbotron">
        <img
          src="static/img/graphics.png"
          alt="graphics"
        >
      </div>
      <h1>
        SECOND – <br>
        EXAMINE IMAGES
      </h1>
      <p>
        An image that accompanies an article or a meme can also
        be misleading. Before you decide that what you are
        looking at is true and share it with others,
        <b>
          make sure that the piece fits the context or that the
          quote it carries is an actual quote.
        </b>
      </p>
    </div>

    <div v-show="page === 5">
      <div class="jumbotron">
        <img
          src="static/img/emotions.png"
          alt="emotions"
        >
      </div>
      <h1>
        THIRD – <br>
        DON’T JUST CLICK, READ!
      </h1>
      <p>
        False information is spread with an aim to make you feel
        strong emotions, which in turn make you click on a link
        or a post. Why? Because clicks are money!
        <b>
          Pay attention to any content that provokes emotions,
          includes numerous exclamation marks, or has all capital titles.
        </b>
      </p>
    </div>

    <div v-show="page === 6">
      <div id="category-selection">
        <h1>Pick the topic you want to explore in the quiz</h1>
        <div class="input">
          <div class="radio">
            <input
              id="all"
              v-model="userInfo.category"
              type="radio"
              value="all"
            >
            <label for="all">
              <div class="icon">
                <img
                  src="static/img/world.svg"
                  alt=""
                >
              </div><div>Surprise me!</div>
            </label>
          </div>
          <div class="radio">
            <input
              id="entertainment"
              v-model="userInfo.category"
              type="radio"
              value="entertainment-en"
            >
            <label for="entertainment">
              <div class="icon">
                <img
                  src="static/img/fireworks.svg"
                  alt=""
                >
              </div><div>Entertainment</div>
            </label>
          </div>
          <div class="radio">
            <input
              id="health"
              v-model="userInfo.category"
              type="radio"
              value="health-en"
            >
            <label for="health">
              <div class="icon">
                <img
                  src="static/img/doctor.svg"
                  alt=""
                >
              </div><div>Health</div>
            </label>
          </div>
          <div class="radio">
            <input
              id="nauka"
              v-model="userInfo.category"
              type="radio"
              value="science-en"
            >
            <label for="nauka">
              <div class="icon">
                <img
                  src="static/img/atom.svg"
                  alt=""
                >
              </div><div>Science</div>
            </label>
          </div>
          <div class="radio">
            <input
              id="polityka"
              v-model="userInfo.category"
              type="radio"
              value="politics-en"
            >
            <label for="polityka">
              <div class="icon">
                <img
                  src="static/img/white-house.svg"
                  alt=""
                >
              </div><div>Politics</div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div v-show="page === 7">
      <div class="jumbotron">
        <img
          src="static/img/lets_begin.png"
          alt="let's begin"
        >
      </div>
      <h1>ALMOST THERE! </h1>
      <p>
        You are going to take the quiz with {{ numOfQuizQuestions }}
        examples of content published online.
        <b>
          Follow your gut feeling and decide which example represents
          fake news by clicking on either FAKE or TRUE.
        </b>
        Examples change every {{ questionTimeoutInSeconds }} seconds,
        which means this is how much time you have to
        make a decision. So, are you ready?
      </p>
    </div>

    <button
      :disabled="incrementPageDisabled"
      :class="incrementPageButtonClass"
      @click="incrementPage"
    >
      {{ incrementPageButtonText }}
    </button>
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations,
} from 'vuex';
import {
  parseQuery,
} from '../utils/location';
import {
  QUESTION_TIMEOUT,
  NUM_OF_QUIZ_QUESTIONS,
} from '../consts';
export default {
  name: 'Intro',
  data() {
    return {
      page: 1,
      userInfo: {
        name: '',
        prediction: 50,
        category: '',
      },
      validationError: false,
    };
  },
  computed: {
    ...mapGetters(['isQuizLoaded']),
    pageTransitions() {
      return {
        6: {
          canGoNext() {
            return this.userInfo.category !== '';
          },
          next() {
            this.setUserInfo(this.userInfo);
            this.generateQuiz();
          },
        },
        7: {
          canGoNext() {
            return this.isQuizLoaded;
          },
          next() {
            this.startQuiz();
          },
        },
      };
    },
    incrementPageEnabled() {
      const pageTransition = this.pageTransitions[this.page];
      if (pageTransition && pageTransition.canGoNext) {
        return pageTransition.canGoNext.call(this);
      }
      return true;
    },
    incrementPageDisabled() {
      return !this.incrementPageEnabled;
    },
    incrementPageButtonText() {
      if (this.page === 1) {
        return 'OK, SHOW ME THE TRICKS';
      }
      if (this.page === 7) {
        if (this.isQuizLoaded) {
          return 'I AM, LET’S DO IT!';
        } else {
          return 'Loading...';
        }
      }
      return 'next';
    },
    incrementPageButtonClass() {
      if (this.page === 7) {
        return 'blue';
      }
      return 'opaque-blue';
    },
    questionTimeoutInSeconds() {
      return QUESTION_TIMEOUT / 1000;
    },
    numOfQuizQuestions() {
      return process.env.NUM_OF_QUIZ_QUESTIONS || NUM_OF_QUIZ_QUESTIONS;
    },
  },
  mounted() {
    this.pingBackend();
    this.fetchManipulationCategories().then(() => {
      const queryParams = parseQuery(window.location.search);
      if (queryParams.results) {
        this.$router.replace({
          name: 'Results',
          params: queryParams,
        });
      }
    });
  },
  methods: {
    ...mapActions([
      'generateQuiz',
      'pingBackend',
      'fetchManipulationCategories',
    ]),
    ...mapMutations([
      'setUserInfo',
    ]),
    incrementPage() {
      const pageTransition = this.pageTransitions[this.page];
      ++this.page;
      if (pageTransition && pageTransition.next) {
        pageTransition.next.call(this);
      }
    },
    startQuiz() {
      localStorage.setItem('category', this.userInfo.category);
      this.$router.push('/quiz');
    },
  },
};
</script>

<style scoped>
#intro {
  color: var(--color-blue);
  background: #EBF1F4;
}

#category-selection h1 {
  margin-bottom:2.5em;
}

div.jumbotron {
  text-align: center;
}
div.jumbotron img {
  width: 85%;
  padding: 0 auto 0 auto;
}

select {
  font-family: 'Montserrat';
  background: white;
  border: none;
  font-weight: 900;
  font-size: 175%;
  color: var(--color-blue);
}

label img {
  height: 1.8em;
  width: auto;
  max-width: 80%;
}

label .icon {
  margin-bottom: 0.6em;
  display: flex;
  align-items: center;
  justify-content: center
}

label .icon + div {
  line-height: 1.1em;
  font-size: 0.85em;
  min-height: 2.2em;
}

label {
  text-align: center;
  background: var(--color-lblue);
  border-radius:0.5em;
  padding:1.5em 0.95em 0.65em 0.95em;
  width: 100%;
  margin-bottom: 0.75em;
  position: relative;
  transition-duration: 0.3s;
}

label:before {
  height: 1.25em;
  width:1.25em;
  position: absolute;
  top:0.75em;
  left:0.75em;
  box-sizing: border-box;
  border-radius: 50%;
  content:'';
  border: 0.125em solid var(--color-border-blue);
  transition-duration: 0.2s;
}

label:after {
  height:0.75em;
  width:0.75em;
  position: absolute;
  top:1em;
  left:1em;
  border-radius: 50%;
  content:'';
  background: var(--color-orange);
  transition-duration: 0.2s;
  opacity: 0;
}

.radio {
  width: calc(50% - 10px);
}

.radio input {
  position: absolute;
  z-index: -9999;
}

.radio input:checked + label {
  background: #fff;
  box-shadow: 0px 0.25em 1.125em #DEE6EA98;
}

.radio input:checked + label:before {
  border-color: var(--color-orange);
}

.radio input:checked + label:after {
  opacity:1;
}

.numbering {
  background: var(--color-orange);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue